<template>
    <v-container fluid>
        <v-snackbar
            :color="notifyColor"
            :timeout="5000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                cols="12"
                md="6"
            >
                <v-card>
                    <v-form
                        ref="claimForm"
                        v-model="isValid"
                    >
                        <v-card-text>
                            <v-container
                                class="pb-0"
                                fluid
                            >
                                <v-row class="pb-0">
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="true"
                                            :items="providers"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Provider"
                                            v-model="claim.providerId"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="true"
                                            :rules="[requiredRule, isNumber]"
                                            label="Incident #"
                                            v-model="claim.incidentId"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="true"
                                            :items="fundingTypes"
                                            :rules="[requiredRule]"
                                            item-text="value"
                                            item-value="key"
                                            label="Funding Type"
                                            v-model="claim.fundingType"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                >
                                    <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="claim.id > 0"
                                    >Delete</v-btn>
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="closeForm"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >Close</v-btn>
                                    <!--<v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        >{{
                                            claim.id > 0 ? "Update" : "Add"
                                    }}</v-btn>-->
                                    <v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        v-show="!(claim.id > 0)"
                                    >Add</v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                md="6"
                no-gutters
            >
                <v-col
                    cols="12"
                    v-show="claim.id > 0"
                >
                    <h3>
                        Claim Batch Files
                        <v-btn
                            :disabled="isLoading || claim.dayBatchId > 0"
                            :loading="isGeneratingClaimBatch"
                            @click="showRequestForm = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-card
                        :key="claimBatch.id"
                        class="mt-5"
                        no-gutters
                        v-for="claimBatch in claim.claimBatches"
                    >
                        <v-card-text class="py-0">
                            <v-row>
                                <v-col cols="8">
                                    BatchNo: {{ claimBatch.batchNumber }}
                                    <br />
                                    Created: {{ claimBatch.createdAt }}
                                </v-col>
                                <v-col
                                    align-self="center"
                                    class="text-center"
                                    cols="4"
                                >
                                    <v-btn
                                        @click.stop="
                                            $store.dispatch('files/get', {
                                                fileId: claimBatch.fileId,
                                                namePrefix: claimBatch.batchNumber.toString(),
                                            })
                                        "
                                        fab
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-col>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
        <v-dialog
            width="800"
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="showRequestForm"
        ><ClaimFormRequestClaimBatchForm
        :claim-id="this.claim.id"
        :claim="this.claim"
        :key="this.claim.id"
        @close="showRequestForm = false"
        @generated="generated"
        @notify="notify"
        />
        </v-dialog>
    </v-container>
</template>

<script>
import Claim from "../../models/Claim.model";
import uuid4 from "../../helpers/uuid4";
import ClaimFormRequestClaimBatchForm from "./ClaimFormRequestClaimBatchForm.vue";
export default {
    props: {
        claimIn: {
            type: Claim,
            default: null
        },
        claimId: {
            type: Number,
            default: 0
        }
    },
    created: async function() {
        this.providers = await this.$store.dispatch("providers/getlist");
        this.fundingTypes = await this.$store.dispatch(
            "accounts/getFundingTypes"
        );
    },
    components: {
        ClaimFormRequestClaimBatchForm
        //
    },
    data() {
        return {
            requestFormId: 0,
            showRequestForm: false,
            populating: true,
            populatingFailure: true,
            claim: new Claim(),
            fundingTypes: [],
            providers: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isGeneratingClaimBatch: null,
            requestId: uuid4(),
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            numericReg: /^\d+$/,
            isNumber: n => this.numericReg.test(n) || "not a whole number"
        };
    },
    mounted: async function() {
        await this.loadClaim();
    },
    computed: {
        //
    },
    methods: {
        async loadClaim() {
            this.populating = true;
            this.populatingFailure = true;

            if (this.claimId > 0) {
                var requestId = (this.requestId = uuid4());
                var claimResponse = await this.$store.dispatch("claims/getClaimPreSubmissionFormDto", {
                    id: this.claimId,
                    urlParameters: {},
                    requestId: requestId
                });
                if (
                    this.requestId == claimResponse.requestId &&
                    claimResponse.data.id == this.claimId
                ) {
                    this.claim = new Claim().set(
                        claimResponse.data
                    );
                    this.populatingFailure = false;
                }

            } else if (this.claimIn != null) {
                this.claim = new Claim().set(this.claimIn);
                this.populatingFailure = false;
            }
            this.populating = false;
        },
        //emitters      ------------------------------------------------------------
        closeForm()
        {
            this.$emit("close");
        },
        notify(message, color)
        {
            this.$emit("notify", message, color);
        },
        //general       ------------------------------------------------------------
        notifyInternal(message, color)
        {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        validateForm() {
            this.isValid = this.$refs.claimForm.validate();
            return this.isValid;
        },
        //generate batchfile
        generated(response)
        {
            while(this.claim.claimBatches.length>0)
            this.claim.claimBatches.pop();
            
            this.claim.claimBatches.push(response);
        },
        generateClaimBatch(claimId) {
            this.isLoading = true;
            this.isGeneratingClaimBatch = true;
            this.$store
                .dispatch("claims/generateClaimBatch", claimId)
                .then(
                    response => {
                        this.claim.claimBatches.push(response);
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.doneGeneratingClaimBatch);
        },
        doneGeneratingClaimBatch() {
            this.isLoading = false;
            this.isGeneratingClaimBatch = false;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                this.claim.incidentId = parseInt(this.claim.incidentId, 10);
                try {
                    var claimWithInfo = await this.$store.dispatch("claims/create",this.claim);
                    this.claimId = claimWithInfo.entity.id;
                    this.notifyInternal("Claim #" + this.claimId + " successfully saved.", "success");
                    await this.loadClaim();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
                }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this claim?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("claims/delete", this.claim.id)
                    .then(
                        () => {
                            this.notify(
                                "Claim #"+ this.claim.id +" successfully deleted.",
                                "success"
                            );
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>